<ng-container *ngIf="genders$ | async as genders">
  <ion-select interface="popover" [formControl]="control" [label]="label">
    <ion-select-option *ngFor="let gender of genders" [value]="gender.id">{{ gender.gender }}</ion-select-option>
  </ion-select>
</ng-container>
